<script setup lang="ts">
import type { CmsBlockImageTextCover } from "@shopware/composables";
import { useCmsBlock } from "#imports";

const props = defineProps<{
  content: CmsBlockImageTextCover;
  class: any;
  style: any;
}>();

const { getSlotContent } = useCmsBlock(props.content);

</script>
<template>
  <!-- empty section fix -->
</template>